
import { useState } from 'react';
import { TrainingSession } from '@/types/training';
import { WeeklyInsight } from '../types/insights';

export function useTimelineDialogs() {
  const [selectedSession, setSelectedSession] = useState<TrainingSession | null>(null);
  const [selectedInsight, setSelectedInsight] = useState<WeeklyInsight | null>(null);
  const [isSessionDialogOpen, setIsSessionDialogOpen] = useState(false);
  const [isInsightDialogOpen, setIsInsightDialogOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState<number | null>(null);

  const handleOpenChange = (open: boolean) => {
    setIsSessionDialogOpen(open);
    if (!open) {
      setSelectedSession(null);
      setCurrentIndex(null);
    }
  };

  const handleInsightOpenChange = (open: boolean) => {
    setIsInsightDialogOpen(open);
    if (!open) {
      setSelectedInsight(null);
    }
  };

  const handleNavigate = (newIndex: number, sessions: TrainingSession[]) => {
    if (sessions[newIndex]) {
      setSelectedSession(sessions[newIndex]);
      setCurrentIndex(newIndex);
    }
  };

  return {
    selectedSession,
    setSelectedSession,
    selectedInsight,
    setSelectedInsight,
    isSessionDialogOpen,
    setIsSessionDialogOpen,
    isInsightDialogOpen,
    setIsInsightDialogOpen,
    currentIndex,
    setCurrentIndex,
    handleOpenChange,
    handleInsightOpenChange,
    handleNavigate,
  };
}
